/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { TivoSubscriptionModel } from '../tivo';

export class DebugScreenController {
    private static TAG: string = 'DebugScreenController';

    private static mDebugScreenController: DebugScreenController | null = null;

    private mToggleScreenSubcription = new TivoSubscriptionModel();

    private mSystemMemoryInfoSubscription = new TivoSubscriptionModel();

    private isDebugScreenEnabled: boolean = false;

    public static getInstance(): DebugScreenController {
        if (DebugScreenController.mDebugScreenController === null) {
            DebugScreenController.mDebugScreenController = new DebugScreenController();
        }
        return DebugScreenController.mDebugScreenController;
    }

    public toggleScreen(): void {
        this.isDebugScreenEnabled = !this.isDebugScreenEnabled;
        this.mToggleScreenSubcription.notify(this.isDebugScreenEnabled);
    }

    public setSystemMemoryInfo(data) {
        this.mSystemMemoryInfoSubscription.notify(data);
    }

    public isScreenEnabled(): boolean {
        return this.isDebugScreenEnabled;
    }

    public getToggleScreenListener(): TivoSubscriptionModel<any> {
        return this.mToggleScreenSubcription;
    }

    public getSystemMemoryEventListener(): TivoSubscriptionModel<any> {
        return this.mSystemMemoryInfoSubscription;
    }
}
